import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { routes } from "./constants";

const ProtectedRoute = ({ isAllowed, redirectUrl = routes.login }) => {
  if (!isAllowed) return <Navigate to={redirectUrl} replace />;
  return <Outlet />;
};

export default ProtectedRoute;


// import React from "react";
// import { Navigate, Outlet } from "react-router-dom";
// import { routes } from "./constants";
// import { useAuth } from "./hooks";

// const ProtectedRoute = ({
//   isAllowed,
//   allowedTypes,
//   redirectUrl = routes.login,
// }) => {
//   const { currentUser } = useAuth();

//   if (
//     !isAllowed ||
//     (allowedTypes && !allowedTypes.includes(currentUser.type))
//   ) {
//     return <Navigate to={redirectUrl} replace={true} />;
//   }

//   return <Outlet />;
// };

// export default ProtectedRoute;

